import React from 'react';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';

import colors from '@totem/styles/colors';
import { isNotNull } from '@totem/utilities/common';

type Variant = 'filled' | 'solid' | 'outlined' | null;

type Props = {
  status: string;
  variant?: Variant;
  label?: string;
};

const StatusTag = ({ status, label, variant = 'outlined' }: Props) => {
  switch (status) {
    case 'success':
      return (
        <Tag
          color={colors.event.criticality.background.ok}
          icon={<CheckCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'processing':
      return (
        <Tag
          color={colors.event.criticality.background.info}
          icon={<SyncOutlined spin />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'warning':
      return (
        <Tag
          color={colors.event.criticality.background.warning}
          icon={<ExclamationCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'error':
      return (
        <Tag
          color={colors.event.criticality.background.critical}
          icon={<CloseCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'ok':
      return (
        <Tag
          color={colors.event.criticality.background.ok}
          icon={<CheckCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'info':
      return (
        <Tag
          color={colors.event.criticality.background.info}
          icon={<CheckCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'minor':
      return (
        <Tag
          color={colors.event.criticality.background.minor}
          icon={<CheckCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'major':
      return (
        <Tag
          color={colors.event.criticality.background.major}
          icon={<CheckCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    case 'critical':
      return (
        <Tag
          color={colors.event.criticality.background.critical}
          icon={<CloseCircleOutlined />}
          variant={variant}
        >
          {isNotNull(label) ? label : status}
        </Tag>
      );
    default:
      return (
        <Tag color={status} icon={<ClockCircleOutlined />} variant={variant}>
          {isNotNull(label) ? label : status}
        </Tag>
      );
  }
};

export default StatusTag;
